import { render, staticRenderFns } from "./EditEmailTemplate.vue?vue&type=template&id=a306e762&scoped=true"
import script from "./EditEmailTemplate.vue?vue&type=script&lang=js"
export * from "./EditEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a306e762",
  null
  
)

export default component.exports